import { getMessages } from "../../../store/constants";

export const SNACKBAR_ID_CARD_NOT_FILLED_ERROR = 'SNACKBAR_ID_CARD_NOT_FILLED_ERROR';
export const SNACKBAR_CARD_NOT_FILLED_TEXT = getMessages().getText('error.card.not_filled');
